/**
 * Единый редактор: в режиме solo — CodeEditor, в режиме collaborative — CollaborativeEditor.
 * Интерфейс различается по режиму (value/onChange для solo, sessionId/onContentChange для collaborative).
 */
import { forwardRef } from 'react';
import CodeEditor from './CodeEditor';
import CollaborativeEditor from './CollaborativeEditor';

const UnifiedEditor = forwardRef(function UnifiedEditor({
  mode = 'solo',
  // solo
  value,
  onChange,
  readOnly = false,
  height = '400px',
  editorSettings,
  // collaborative
  sessionId,
  onContentChange,
  theme = 'dark',
  onThemeChange,
  onYdocReady,
  onRunRequest,
  onStatusChange,
  styleLintEnabled,
  onStyleLintChange,
  onFormattingChange,
}, ref) {
  if (mode === 'collaborative') {
    return (
      <CollaborativeEditor
        ref={ref}
        sessionId={sessionId}
        onContentChange={onContentChange}
        theme={theme}
        onThemeChange={onThemeChange}
        onYdocReady={onYdocReady}
        onRunRequest={onRunRequest}
        onStatusChange={onStatusChange}
        editorSettings={editorSettings}
        styleLintEnabled={styleLintEnabled}
        onStyleLintChange={onStyleLintChange}
        onFormattingChange={onFormattingChange}
      />
    );
  }

  return (
    <CodeEditor
      value={value ?? ''}
      onChange={onChange}
      readOnly={readOnly}
      height={height}
      editorSettings={editorSettings}
    />
  );
});

export default UnifiedEditor;
